/**
 * Метод для получения минимально возможной предоплаты туров из массива тур продуктов.
 */

import _ from 'underscore';

 const getMinFirstPaymentPartFromProducts = (tourOrHotelProducts) => {
     const firstPaymentParts = _.reduce(tourOrHotelProducts, (acc, tourOrHotelProduct) => {
         const firstPaymentPart = tourOrHotelProduct?.firstPaymentDefinition?.firstPaymentPart;
         const isUniqValue = !~acc.indexOf(firstPaymentPart);

         if (isUniqValue && firstPaymentPart && firstPaymentPart !== Infinity) {
             acc.push(firstPaymentPart);
         }

         return acc;
     }, []);

     return _.min(firstPaymentParts);
};

export default getMinFirstPaymentPartFromProducts;
